module.exports = __webpack_public_path__ + "static/media/bvlgari.f3c18e81.jpg";